import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { useForm } from 'hooks/useForm'
import React, { useCallback, useEffect, useImperativeHandle, useState, forwardRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Snackbars from "components/Snackbar/Snackbar.js";
import { editProduct, createNewProduct } from 'redux/actions/productsCatalog/productsCatalogActions'

export const FormProductEdit = forwardRef((props, ref) => {
  const { handleClose } = props
  const { productSelected, addMode, deleteMode } = useSelector(state => state.productsCatalog)
  const { token } = useSelector(state => state.login)
  const [snackBar, setSnackBar] = useState(false)
  const { inputValues, handleInputOnChange, handleNewValues } = useForm({
    consecutive: '',
    name: '',
    satProductCode: '',
    satUnitCode: '',
    capacity: '',
    type: '',
    measureUnit: '',
    display: '',
  })
  const dispatch = useDispatch()
  const { consecutive, name, satProductCode, satUnitCode, capacity, type, measureUnit, display } = inputValues
  
  const handleSubmit = useCallback(async() => {
    const newValues = {
      ...productSelected,
      consecutive: parseInt(consecutive),
      name,
      satProductCode: satProductCode,
      measureUnit,
      satUnitCode,
      type,
      display,
      capacity: parseInt(capacity),
    }

    if( newValues.consecutive > 0 && name.length > 0 && satProductCode.length > 0 && measureUnit.length > 0 && satUnitCode.length > 0 && type.length > 0 && newValues.capacity > 0 && display.length > 0 ) {
      if(addMode){
        dispatch(createNewProduct(newValues, token))
        handleClose()
      } else {
        dispatch(editProduct(productSelected.id, newValues, token))
        handleClose()
      }
    } else {
      setSnackBar(true)
    }
  }, [consecutive, name, satProductCode, satUnitCode, capacity, type, measureUnit, display, addMode, productSelected, token, handleClose])

  useImperativeHandle(ref, () => ({
    submit: handleSubmit
  }), [handleSubmit])

  useEffect(() => {
    if (productSelected) {
      handleNewValues({
        consecutive: productSelected.consecutive,
        name: productSelected.name,
        satProductCode: productSelected.satProductCode,
        satUnitCode: productSelected.satUnitCode,
        capacity: productSelected.capacity,
        measureUnit: productSelected.measureUnit,
        type: productSelected.type,
        display: productSelected.display
      })
    } else {
      handleNewValues({
        satProductCode: "15111510"
      })
    }
    // eslint-disable-next-line
  }, [productSelected])

  return (
    <>
      <FormControl fullWidth style={{display: 'flex', gap: 10, marginTop: 20}} onSubmit={handleSubmit}>
        <TextField type="text" label="Nombre *" name="name" value={name} disabled={deleteMode} onChange={handleInputOnChange} variant="outlined" />
        <TextField type="number" label="Consecutivo *" name="consecutive" value={consecutive} disabled={deleteMode} onChange={handleInputOnChange} variant="outlined" />
        <TextField type="number" label="SAT Codigo de producto *" name="satProductCode" value={"15111510"} disabled={true} onChange={handleInputOnChange} variant="outlined" />
        <TextField type="text" label="SAT Codigo de unidad *" name="satUnitCode" value={satUnitCode} disabled={deleteMode} onChange={handleInputOnChange} variant="outlined" />
        <TextField type="number" label="Capacidad *" name="capacity" value={capacity} disabled={deleteMode} onChange={handleInputOnChange} variant="outlined" />
        <FormControl fullWidth variant="outlined">
          <InputLabel id="demo-simple-select-outlined-label" >Unidad de Medida *</InputLabel>
              <Select
                id="demo-simple-select-outlined"
                value={measureUnit}
                name="measureUnit"
                onChange={handleInputOnChange}
                label="Unidad de Medida *"
                disabled={deleteMode}
              >
                <MenuItem value="">
                  <em>Seleccione una unidad de medida</em>
                </MenuItem>
                <MenuItem value="CILINDRO">CILINDRO</MenuItem>
                <MenuItem value="LTS">LTS</MenuItem>
                <MenuItem value="KGS">KGS</MenuItem>
              </Select>
        </FormControl>
        <FormControl fullWidth variant="outlined">
          <InputLabel id="demo-simple-select-outlined-label" >Tipo *</InputLabel>
            <Select
              value={type}
              name="type"
              onChange={handleInputOnChange}
              label="Tipo *"
              disabled={deleteMode}
            >
              <MenuItem value="">
                <em>Seleccione un tipo</em>
              </MenuItem>
              <MenuItem value="PORTATIL">PORTATIL</MenuItem>
              <MenuItem value="ESTACION">ESTACION</MenuItem>
              <MenuItem value="ESTACIONARIO">ESTACIONARIO</MenuItem>
              <MenuItem value="OTRO PRODUCTO">OTRO PRODUCTO</MenuItem>
            </Select>
        </FormControl>
        <FormControl fullWidth variant="outlined">
          <InputLabel id="demo-simple-select-outlined-label" >Visualización *</InputLabel>
            <Select
              value={display}
              name="display"
              onChange={handleInputOnChange}
              label="Visualización *"
              disabled={deleteMode}
              className="input_custom_font"
            >
              <MenuItem value="">
                <em>Seleccione un tipo</em>
              </MenuItem>
              <MenuItem value="MOBILE">MOBILE</MenuItem>
              <MenuItem value="NONE">NONE</MenuItem>
            </Select>
        </FormControl>
      </FormControl>
      <Snackbars
        place="tr"
        color='danger'
        message="Campos con * son requeridos"
        open={snackBar}
        closeNotification={() => setSnackBar(false)}
        close
      /> 
    </>
  )
})
